/**
 * キャッチアイコンの表示判定（商品ページ・一覧カード共通）。
 *
 * 管理画面が配るのは「条件」と「見た目」だけで、条件に当てはまるかどうかの判定は
 * ここで行う。理由は在庫にある。管理画面が持っているのは倉庫の物理在庫で、
 * Shopify の購入可能数とは未出荷注文の分だけ意味がずれる。そちらで判定すると
 * 「完売なのに LOW STOCK」が起きるため、ページを表示する時点の在庫で判断する。
 *
 * 商品ページと一覧カードで別々に実装すると、同じ商品なのに片方だけバッジが出る
 * という食い違いが起きる。判定はこのファイルに一本化して、両方から呼ぶ。
 *
 * 入力（呼び出し側が Liquid から読む値）:
 *   minStock    - 在庫がある中での最小値。'0'〜'5' と '6+'。在庫数そのものは渡らない
 *   hasPreorder - 予約告知（custom._preorder）が設定されているか
 */
(function () {
  if (window.ItemManagerCatchIconRules) return;

  var DEFAULT_MAX_COUNT = 2;

  function normalizeCode(value) {
    return String(value || '').trim();
  }

  /**
   * 在庫バケットを数値にする。
   * '6+' は「閾値の上限 5 より多い」ことしか分からないので対象外を返す。
   * '0'（在庫なし＝完売）も対象外。
   */
  function parseStockBucket(value) {
    var raw = String(value == null ? '' : value).trim();
    if (raw === '' || raw === '6+') return null;
    var parsed = parseInt(raw, 10);
    if (!isFinite(parsed) || parsed <= 0) return null;
    return parsed;
  }

  function matchesRule(rule, ctx) {
    if (!rule || !rule.title) return false;

    if (rule.type === 'low_stock') {
      var stock = parseStockBucket(ctx.minStock);
      if (stock === null) return false;
      var min = typeof rule.stockMin === 'number' ? rule.stockMin : 1;
      var max = typeof rule.stockMax === 'number' ? rule.stockMax : 5;
      return stock >= min && stock <= max;
    }

    if (rule.type === 'preorder') {
      if (!ctx.hasPreorder) return false;
      // 予約告知は残っているが予約期間が終わっている商品。
      // 管理画面が 1 日 1 回、商品ページを見て判定している。
      return ctx.expiredCodes.indexOf(ctx.productCode) === -1;
    }

    return false;
  }

  /**
   * 表示順。
   *
   * 手動バッジの sortOrder は「その品番をアイコンへ登録した順の連番」で、
   * アイコンの種類とは無関係な値が入る（実測で 0,1,2,4,7,8…）。自動バッジの
   * sortOrder はアイコン自体の並び順なので、両者をそのまま比べると
   * 同じ組み合わせでも品番ごとに前後が入れ替わる（実測: 98020 は
   * COMINGSOON→LOW STOCK、98021 は LOW STOCK→COMINGSOON）。
   *
   * そこで「販売形態（PREORDER）→ 在庫状況（LOW STOCK）→ 販促ラベル（手動）」
   * の順に固定する。同じ層の中では従来どおり sortOrder とタイトルで並べる。
   */
  var GROUP_PREORDER = 0;
  var GROUP_LOW_STOCK = 1;
  var GROUP_MANUAL = 2;

  function groupOf(icon) {
    if (icon.autoType === 'preorder') return GROUP_PREORDER;
    if (icon.autoType === 'low_stock') return GROUP_LOW_STOCK;
    return GROUP_MANUAL;
  }

  function compareIcons(a, b) {
    var ga = groupOf(a);
    var gb = groupOf(b);
    if (ga !== gb) return ga - gb;
    if (a.sortOrder !== b.sortOrder) return a.sortOrder - b.sortOrder;
    return String(a.title).localeCompare(String(b.title), 'ja');
  }

  /**
   * 表示するバッジを決める。
   *
   * @param {object} options
   * @param {object} options.payload     配信 API のレスポンス
   * @param {string} options.productCode 品番（product.handle）
   * @param {string} options.minStock    在庫バケット
   * @param {boolean} options.hasPreorder 予約告知の有無
   * @param {number} [options.maxCount]  表示上限（既定 2）
   * @returns {Array<{id:string,title:string,fontColor:string,backgroundColor:string,sortOrder:number}>}
   */
  function resolve(options) {
    var opts = options || {};
    var payload = opts.payload || {};
    var productCode = normalizeCode(opts.productCode);
    if (!productCode) return [];

    var productIcons = payload.productIcons || {};
    var manual = Array.isArray(productIcons[productCode])
      ? productIcons[productCode]
      : [];
    var autoRules = Array.isArray(payload.autoRules) ? payload.autoRules : [];
    var expiredCodes = Array.isArray(payload.preorderExpiredCodes)
      ? payload.preorderExpiredCodes
      : [];

    var ctx = {
      productCode: productCode,
      minStock: opts.minStock,
      hasPreorder: opts.hasPreorder === true,
      expiredCodes: expiredCodes
    };

    var icons = manual.slice();
    var seenTitles = {};
    icons.forEach(function (icon) {
      if (icon && icon.title) seenTitles[icon.title] = true;
    });

    autoRules.forEach(function (rule) {
      if (!matchesRule(rule, ctx)) return;
      // 同じ文言の手動バッジが残っている場合に二重で出さない。
      if (seenTitles[rule.title]) return;
      seenTitles[rule.title] = true;
      icons.push({
        id: rule.id,
        title: rule.title,
        fontColor: rule.fontColor,
        backgroundColor: rule.backgroundColor,
        sortOrder: typeof rule.sortOrder === 'number' ? rule.sortOrder : 0,
        autoType: rule.type
      });
    });

    icons.sort(compareIcons);

    var maxCount =
      typeof opts.maxCount === 'number' && opts.maxCount > 0
        ? opts.maxCount
        : DEFAULT_MAX_COUNT;
    return icons.slice(0, maxCount);
  }

  window.ItemManagerCatchIconRules = {
    resolve: resolve,
    // テスト用に公開する
    matchesRule: matchesRule,
    parseStockBucket: parseStockBucket,
    DEFAULT_MAX_COUNT: DEFAULT_MAX_COUNT
  };
})();
